import React from 'react';
import { Loader2 } from 'lucide-react';
import InterviewModal from './InterviewModal';

export default function PrePitchModal({ isOpen, onClose, onStart, isDarkMode, sessionSetUpLoading }) {
  const steps = [
    "You'll record ONE take of your elevator pitch — no questions asked.",
    "A countdown timer runs for the length you picked (30, 60, or 90 seconds). Recording stops automatically at zero.",
    "You can re-record as many times as you want before submitting.",
    "Your pitch is recorded through your mic, which is already confirmed working.",
    "Scoring and feedback are generated after you submit, not live.",
    "Your results are private to you and are not shared with coaches or anyone else.",
  ];

  return (
    <InterviewModal
      isOpen={isOpen}
      onClose={sessionSetUpLoading ? () => {} : onClose}
      isDarkMode={isDarkMode}
      title={sessionSetUpLoading ? 'Setting Up' : 'Before You Start'}
      footer={sessionSetUpLoading ? null : (
        <>
          <button
            type="button"
            onClick={onClose}
            className={`px-4 py-2 rounded-xl text-sm font-semibold transition-colors ${
              isDarkMode ? 'bg-slate-800 text-slate-200 hover:bg-slate-700' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
            }`}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onStart}
            className="px-5 py-2 rounded-xl text-sm font-semibold text-white bg-primary-600 hover:bg-primary-500 transition-colors"
          >
            Start
          </button>
        </>
      )}
    >
      {sessionSetUpLoading ? (
        <div className="flex flex-col items-center justify-center gap-4 py-12">
          <Loader2 size={48} className={`animate-spin ${isDarkMode ? 'text-primary-400' : 'text-primary-600'}`} />
          <p className={`text-lg font-bold ${isDarkMode ? 'text-slate-100' : 'text-slate-900'}`}>Setting Up</p>
          <p className={`text-sm text-center ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
            Hang tight while we get your session ready...
          </p>
        </div>
      ) : (
        <>
          <p className={`text-sm mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-600'}`}>Here's what to expect:</p>
          <ul className="space-y-3">
            {steps.map((step, i) => (
              <li key={i} className="flex items-start gap-3">
                <span className={`mt-0.5 flex-shrink-0 flex items-center justify-center w-5 h-5 rounded-full text-[10px] font-bold ${
                  isDarkMode
                    ? 'bg-primary-400/10 text-primary-400 border border-primary-400/40'
                    : 'bg-primary-500/10 text-primary-600 border border-primary-500/50'
                }`}>
                  {i + 1}
                </span>
                <span className={`text-sm ${isDarkMode ? 'text-slate-200' : 'text-slate-700'}`}>{step}</span>
              </li>
            ))}
          </ul>
        </>
      )}
    </InterviewModal>
  );
}
